export function extractFirstNumericSequence(text: string): string | null {
  if (!text) return null

  // 1) Prefer a long contiguous digit sequence (4+ digits) — common for IDs like 776800
  let matches = text.match(/\d{4,}/g)
  if (matches && matches.length) return matches[0]

  // 2) Try to capture digit groups that may be separated by spaces or dashes
  //    e.g. "77 68-00" or "7 7 6 8 0 0" -> capture and strip non-digits
  const grouped = text.match(/(?:\d[\s-]*){4,}/g)
  if (grouped && grouped.length) {
    return grouped[0].replace(/\D/g, '')
  }

  // 3) Fallback: take the longest contiguous digit group found
  matches = text.match(/\d+/g)
  if (matches && matches.length) {
    matches.sort((a, b) => b.length - a.length)
    return matches[0]
  }

  // 4) Last resort: concatenate all single digits in order (if any)
  const all = (text.match(/\d/g) || []).join('')
  return all.length ? all : null
}

export function extractAllDigits(text: string): string {
  if (!text) return ''
  return (text.match(/\d+/g) || []).join('')
}
